import { createApp } from "vue";
import App from "./App.vue";
import "vuetify/styles";
// reset style sheet
import "@/styles/reset.scss";
// CSS common style sheet
import "@/styles/common.scss";
// fallback variables for legacy --el-* tokens
import "@/styles/element-vars-fallback.scss";
import "../index.css";

// iconfont css
import "@/assets/iconfont/iconfont.scss";
// font css
import "@/assets/fonts/font.scss";
// custom element dark css
import "@/styles/element-dark.scss";
// custom element css
import "@/styles/element.scss";
// svg icons
import "virtual:svg-icons-register";
// custom directives
import directive from "@/directives/index";
// vue Router
import router from "@/router";
// vue i18n
import I18n from "@/languages/index";
// pinia store
import { setupStore } from "@/store";
// errorHandler
import errorHandler from "@/utils/errorHandler";
// map
// import VueGoogleMaps from "@fawmi/vue-google-maps";

import { createVuetify } from "vuetify";

import * as components from "vuetify/components";

import * as directives from "vuetify/directives";

import mitt from "mitt";

const vuetify = createVuetify({
  components,
  directives,
  defaults: {
    VBtn: {
      density: "compact"
    },
    VAutocomplete: {
      autocomplete: "new-password",
      name: "no-browser-autofill-autocomplete",
      spellcheck: false
    },
    VCombobox: {
      autocomplete: "new-password",
      name: "no-browser-autofill-combobox",
      spellcheck: false
    },
    VSelect: {
      autocomplete: "new-password",
      name: "no-browser-autofill-select",
      spellcheck: false
    }
  }
});

const disableBrowserAutocompleteForVuetifySelects = () => {
  const inputNames = new WeakMap<HTMLInputElement, string>();
  let inputIndex = 0;

  const disableInputAutocomplete = (input: HTMLInputElement) => {
    if (!inputNames.has(input)) {
      inputNames.set(input, `viot-no-browser-autofill-${Date.now()}-${inputIndex++}`);
    }
    input.setAttribute("autocomplete", "new-password");
    input.setAttribute("autocorrect", "off");
    input.setAttribute("autocapitalize", "off");
    input.setAttribute("spellcheck", "false");
    input.setAttribute("data-form-type", "other");
    input.setAttribute("name", inputNames.get(input) || "viot-no-browser-autofill");
  };

  const disableAll = () => {
    document
      .querySelectorAll<HTMLInputElement>(
        ".v-select input, .v-autocomplete input, .v-combobox input, input[role='combobox']"
      )
      .forEach(disableInputAutocomplete);
  };

  disableAll();
  document.addEventListener(
    "focusin",
    (event) => {
      const target = event.target;
      if (
        target instanceof HTMLInputElement &&
        (target.closest(".v-select") ||
          target.closest(".v-autocomplete") ||
          target.closest(".v-combobox") ||
          target.getAttribute("role") === "combobox")
      ) {
        disableInputAutocomplete(target);
      }
    },
    true
  );

  new MutationObserver(() => {
    window.requestAnimationFrame(disableAll);
  }).observe(document.body, {
    childList: true,
    subtree: true
  });
};

const app = createApp(App);

app.config.errorHandler = errorHandler;
import { useUserStoreWithOut } from "@/store/modules/user";
const userStore = useUserStoreWithOut();
const role = userStore.getRoles;
app.config.globalProperties.$GlobalRole = role || [];

app.config.globalProperties.mittBus = mitt();

setupStore(app);
app.use(directive).use(router).use(I18n).use(vuetify).mount("#app");
disableBrowserAutocompleteForVuetifySelects();
